module.exports = __webpack_public_path__ + "static/media/playstore-download.cc4264b0.png";